var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon34(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.949219 20H5.23493H10.9492H15.2349L10.8778 9C10.6397 8.42857 10.2706 7.97619 9.77065 7.64286C9.27065 7.30953 8.71112 7.14286 8.09208 7.14286C7.47303 7.14286 6.9135 7.30953 6.4135 7.64286C5.9135 7.97619 5.54446 8.42857 5.30636 9L0.949219 20ZM6.0735 4.87429C6.6335 5.43429 7.30636 5.71429 8.09208 5.71429C8.87684 5.71524 9.54922 5.43572 10.1092 4.87572C10.6692 4.31572 10.9492 3.64286 10.9492 2.85715C10.9502 2.07238 10.6706 1.4 10.1106 0.840002C9.55065 0.280003 8.87779 2.42542e-06 8.09208 2.42542e-06C7.30731 -0.000949956 6.63493 0.278574 6.07493 0.838574C5.51493 1.39857 5.23493 2.07143 5.23493 2.85715C5.23398 3.64191 5.5135 4.31429 6.0735 4.87429Z",
    fill: "url(#paint0_linear_46_9517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_9517",
    x1: 8.09208,
    y1: -3.6,
    x2: 8.09208,
    y2: 23.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon34);
export default __webpack_public_path__ + "static/media/icon34.138359dc9795caae7167962ca84f00e9.svg";
export { ForwardRef as ReactComponent };